import computeClassName from '../../../../../../../utils/computeClassName';

export default function CCIconSocialLinkedIn20x20({ className }) {
  const computedClassName = computeClassName(className, '');
  return (
    <svg className={computedClassName} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="20" height="20" rx="2" fill="#939595"/>
      <path d="M6.66683 15.8333H4.16683V6.66659H6.66683V15.8333ZM5.41683 5.60992C4.61183 5.60992 3.9585 4.95159 3.9585 4.13992C3.9585 3.32826 4.61183 2.66992 5.41683 2.66992C6.22183 2.66992 6.87516 3.32826 6.87516 4.13992C6.87516 4.95159 6.22266 5.60992 5.41683 5.60992ZM16.6668 15.8333H14.1668V11.1633C14.1668 8.35659 10.8335 8.56909 10.8335 11.1633V15.8333H8.3335V6.66659H10.8335V8.13742C11.9968 5.98242 16.6668 5.82326 16.6668 10.2008V15.8333Z" fill="white"/>
    </svg>
  );
}

